import type { MaterialComponentInputValue, MaterialComponentValue } from 'api';
import { type MaterialComponentValueType } from 'features';

export const convertToOrderInputMaterialComponents = (
  materialComponentValue: MaterialComponentValueType[]
): MaterialComponentInputValue[] => {
  return materialComponentValue.map((materialComponentValue) => ({
    boolean_value: materialComponentValue.boolean_value ?? undefined,
    max_value: materialComponentValue.max_value ? materialComponentValue.max_value.toString() : undefined,
    min_value: materialComponentValue.min_value ? materialComponentValue.min_value.toString() : undefined,
    supported_component_id: materialComponentValue.supported_component_id,
  }));
};

export const convertOrderMaterialComponentValuesToForm = (materialComponentValues: MaterialComponentValue[]) => {
  return materialComponentValues
    .filter((materialComponentValue) => materialComponentValue.supported_component)
    .map((materialComponentValue) => ({
      boolean_value: materialComponentValue.boolean_value ?? undefined,
      max_value: materialComponentValue.max_value ? Number(materialComponentValue.max_value) : undefined,
      min_value: materialComponentValue.min_value ? Number(materialComponentValue.min_value) : undefined,
      supported_component_id: materialComponentValue.supported_component.id,
    }));
};
